// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content.svelte-1uxzan9{max-width:800px;margin:28px auto;padding:0 6px}.text.svelte-1uxzan9{text-align:center;font-size:18px;font-weight:500;color:var(--secondary);margin-top:-12px}@media(max-width: 600px){.content.svelte-1uxzan9{margin:18px auto 28px}.text.svelte-1uxzan9{font-size:17px}}", ""]);
// Exports
module.exports = exports;
